export default __webpack_public_path__ + "static/media/image.b4f1824c.svg";